export const getPrizeCollectionWinners = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/surface/CarCollectionsSurface/GetCarCollections`);
